export const ENV = {
  // API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_BASE_URL: "https://demo9.stsgram.com"
  // API_BASE_URL: "http://localhost:1339"
  // API_BASE_URL: "http://localhost:1337"

};
